import { useEffect, useState } from "react";
import { publicAPI } from "@/services/api";
import { Building2, Mail, MapPin, Phone } from "lucide-react";

const FALLBACK_SETTINGS = {
  company_display_name: "ARTICO-MMJ",
  legal_name: "ARTICO SARLU",
  support_phone: "+243 XXX XXX XXX",
  whatsapp_phone: "+243 XXX XXX XXX",
  official_email: "artico@mymmj.app",
  support_email: "artico@mymmj.app",
  headquarters_address: "République démocratique du Congo",
};

export default function ContactInfoBlock({ className = "", compact = false }) {
  const [settings, setSettings] = useState(FALLBACK_SETTINGS);

  useEffect(() => {
    let alive = true;
    publicAPI.getPlatformSettings()
      .then((response) => {
        if (alive && response.data) setSettings({ ...FALLBACK_SETTINGS, ...response.data });
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  const rows = [
    { icon: Building2, label: "Organisation", value: settings.legal_name || settings.company_display_name },
    { icon: Phone, label: "Telephone", value: settings.support_phone || settings.whatsapp_phone },
    { icon: Mail, label: "E-mail", value: settings.support_email || settings.official_email },
    { icon: MapPin, label: "Adresse", value: settings.headquarters_address },
  ].filter((row) => row.value);

  if (compact) {
    const footerItems = [
      settings.legal_name || settings.company_display_name,
      settings.support_phone || settings.whatsapp_phone,
      settings.support_email || settings.official_email,
      settings.headquarters_address,
    ].filter(Boolean);

    return (
      <p className={`mx-auto max-w-5xl text-center text-xs leading-6 text-[#5C625F] sm:text-sm ${className}`}>
        {footerItems.map((item, index) => (
          <span key={`${item}-${index}`}>
            {index > 0 && <span className="mx-2 text-[#D4A373]">|</span>}
            <span>{item}</span>
          </span>
        ))}
      </p>
    );
  }

  return (
    <section className={`rounded-xl border border-[#E6E4E0] bg-white p-4 shadow-sm ${className}`}>
      <h2 className="text-sm font-semibold uppercase tracking-[0.12em] text-[#D4A373]">Contact ARTICO-MMJ</h2>
      <div className="mt-3 grid gap-2 text-sm text-[#5C625F] sm:grid-cols-2">
        {rows.map(({ icon: Icon, label, value }) => (
          <div key={label} className="flex gap-2 rounded-lg bg-[#F9F7F4] p-3">
            <Icon size={16} className="mt-0.5 shrink-0 text-[#2A4B46]" />
            <div>
              <p className="font-semibold text-[#2A4B46]">{label}</p>
              <p className="break-words">{value}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
